import {
  PHOBIA_LIST_ALPABETICAL,
  DISORDER_LIST,
  PHOBIA_ACTION_MAP,
} from "@/config";
import { generate } from "shortid";
import { PAGE_THEMES, PAGE_TYPES } from "@/config/pages/types";
import { getCategoryById } from "@/utils";
import { TARGET_DATA } from "@/config/forms";

export const PARTNER_WELCOME_PAGES = {
  partner_choose_problem_page: {
    id: `choose_problem_page-${generate()}`,
    type: "single_select_type",
    title: null,
    module_name: "partner_welcome",
    backwards_navigation_enabled: false,
    target_state: "welcome_data",
    target_field: "choose_problem",
    target_component: null,
    component_type: null,
    target_pages: [
      {
        name: "program_how_vr_works_page",
        data_key: "default_progression",
        action: () => {
          return "partner_payment_setup_account_page";
        },
      },
      {
        name: "anxiety_profile_comfortability_page",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 4:
              return PHOBIA_ACTION_MAP.social_anxiety.comfortable_lables.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            default:
              return [];
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 4:
              return PHOBIA_ACTION_MAP.social_anxiety.fear_of_labels.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            default:
              return [];
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "title",
        action: (data) => {
          let title = "What is it about {{phobia}} that actually scares you?";

          switch (data) {
            case 4:
              return title.replace("{{phobia}}", "social situations");
            default:
              return title.replace("{{phobia}}", "your phobia");
          }
        },
      },
      {
        name: "phobia_info_page",
        data_key: "default_progression",
        action: (data) => {
          switch (data) {
            case 4:
              return "anxiety_profile_goals_info_page";
            default:
              return "celebrate_page";
          }
        },
      },
      {
        name: "phobia_info_page",
        data_key: "title",
        action: (data) => {
          const disorder = DISORDER_LIST.find((opt) => opt.value === data);

          if (disorder) {
            return getCategoryById(disorder.value).statement.title;
          }

          return null;
        },
      },
      {
        name: "phobia_info_page",
        data_key: "description",
        action: (data) => {
          const disorder = DISORDER_LIST.find((opt) => opt.value === data);

          if (disorder) {
            return getCategoryById(disorder.value).statement.description;
          }

          return null;
        },
      },
      {
        name: "treatment_select_page",
        data_key: "title",
        action: (data) => {
          const disorder = DISORDER_LIST.find((opt) => opt.value === data);

          if (disorder) {
            return `Have you tried treating your ${getCategoryById(
              data
            ).title.toLocaleLowerCase()}?`;
          }

          return null;
        },
      },
    ],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What do you need help with?",
      description: "Choose one that affects you most day to day",
      image: null,
      custom_back: null,
      default_progression: null,
      options: [
        {
          id: `option-item-2-${generate()}`,
          label: "A phobia",
          to: "choose_phobia_page",
          text: "See all →",
          value: "phobia",
          target_field: "choose_problem",
          icon: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-0-${generate()}`,
          label: "Social Anxiety",
          to: "phobia_info_page",
          icon: "social-anxiety",
          value: 4,
          target_field: "choose_phobias",
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "Mild Depression",
          to: "phobia_info_page",
          icon: "programs/mild-depression",
          value: 1001,
          target_field: "choose_phobias",
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  choose_phobia_page: {
    id: `choose_phobia_page-${generate()}`,
    type: "single_select_type",
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "choose_phobias",
    target_pages: [
      {
        name: "anxiety_profile_comfortability_page",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 6:
              return PHOBIA_ACTION_MAP.acrophobia.comfortable_lables.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            case 7:
              return PHOBIA_ACTION_MAP.aerophobia.comfortable_lables.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            default:
              return [];
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 6:
              return PHOBIA_ACTION_MAP.acrophobia.fear_of_labels.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            case 7:
              return PHOBIA_ACTION_MAP.aerophobia.fear_of_labels.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            default:
              return [];
          }
        },
      },
      {
        name: "phobia_info_page",
        data_key: "default_progression",
        action: (data) => {
          switch (data) {
            case 6:
            case 7:
              return "anxiety_profile_goals_info_page";
            default:
              return "celebrate_page";
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "title",
        action: (data) => {
          let title = "What is it about {{phobia}} that actually scares you?";

          switch (data) {
            case 6:
              return title.replace("{{phobia}}", "heights");
            case 7:
              return title.replace("{{phobia}}", "flying");
            default:
              return title.replace("{{phobia}}", "your phobia");
          }
        },
      },
      {
        name: "phobia_info_page",
        data_key: "title",
        action: (data) => {
          return getCategoryById(data).statement.title;
        },
      },
      {
        name: "phobia_info_page",
        data_key: "description",
        action: (data) => {
          return getCategoryById(data).statement.description;
        },
      },
      {
        name: "treatment_select_page",
        data_key: "title",
        action: (data) => {
          return `Have you tried treating your ${getCategoryById(data).title}?`;
        },
      },
    ],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What do you need help with?",
      description: "Choose one that affects you most day to day",
      image: null,
      custom_back: null,
      default_progression: "choose_problem_page",
      options: PHOBIA_LIST_ALPABETICAL.map((phobia, i) => ({
        id: `option-item-${i}-${generate()}`,
        label: phobia.description,
        description: phobia.title,
        icon: phobia.image,
        target_field: "choose_phobias",
        to: "phobia_info_page",
        value: phobia.id,
        content: phobia.text,
        isActive: false,
      })),
    },
  },
  phobia_info_page: {
    id: `phobia_info_page-${generate()}`,
    type: "info_type",
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_welcome",
    target_state: null,
    target_field: null,
    theme: PAGE_THEMES.WARM,
    target_pages: [],
    data: {
      title: "Did you know that 9.1% of people suffer from phobias?",
      description:
        "Everybody is scared of something. But when that fear starts to get in the way of your daily life - it’s time to get rid of your phobia for good!",
      image: "illustrations/anxious",
      custom_back: null,
      default_progression: "name_input_page",
      options: [],
    },
  },
  celebrate_page: {
    id: `celebrate_page-${generate()}`,
    type: PAGE_TYPES.details,
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "You’re in good hands",
      description: "86.5%",
      image: null,
      custom_back: null,
      default_progression: "treatment_select_page",
      options: [
        {
          id: `extra-content-1-${generate()}`,
          label: "of people using oVRcome experienced a reduction in anxiety.",
          value: null,
          target_field: null,
          to: null,
          icon: "orgs/uoo",
          text: "*Lacey, C., Frampton, C., & Beaglehole, B. (2022). oVRcome – Self-guided virtual reality for specific phobias: A randomised controlled trial. Australian & New Zealand Journal of Psychiatry, 000486742211107. https:// doi.org/10.1177/00048674221110779",
          description: "Proven in a controlled clinical trial",
          isActive: false,
        },
      ],
    },
  },
  name_input_page: {
    id: `name_input_page-${generate()}`,
    type: "input_type",
    backwards_navigation_enabled: true,
    title: "Your profile",
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "name_input",
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What's your name?",
      description: null,
      image: null,
      custom_back: null,
      default_progression: "age_select_page",
      options: [],
    },
  },
  age_select_page: {
    id: `age_select_page-${generate()}`,
    type: "single_select_type",
    backwards_navigation_enabled: true,
    title: "Your profile",
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "age_select",
    target_pages: [],
    component_type: "centered",
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "How old are you?",
      description: "We’ll tailor your program to your age group",
      image: null,
      default_progression: "gender_select_page",
      custom_back: null,
      options: [
        {
          id: `option-item-0-${generate()}`,
          label: "18 - 25",
          to: "gender_select_page",
          value: "18-25",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "26 - 35",
          to: "gender_select_page",
          value: "26-35",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "36 - 45",
          to: "gender_select_page",
          value: "36-45",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-3-${generate()}`,
          label: "45 - 55",
          to: "gender_select_page",
          value: "45-55",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-4-${generate()}`,
          label: "56+",
          value: "56+",
          to: "gender_select_page",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  gender_select_page: {
    id: `gender_select_page-${generate()}`,
    type: "single_select_type",
    backwards_navigation_enabled: true,
    title: "Your profile",
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "choose_gender",
    target_pages: [],
    component_type: "centered",
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What's your gender?",
      description:
        "This helps us personalize your plan. Gender affects anxiety. We also experience anxiety differently across genders.",
      image: null,
      custom_back: null,
      default_progression: null,
      options: [
        {
          id: `option-item-0-${generate()}`,
          label: "Male",
          to: "program_category_page",
          value: "male",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "Female",
          to: "program_category_page",
          value: "female",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "Gender diverse",
          to: "program_category_page",
          value: "diverse",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-3-${generate()}`,
          label: "Prefer not to say",
          to: "program_category_page",
          value: "unknown",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  treatment_select_page: {
    id: `treatment_select_page-${generate()}`,
    type: "multi_select_type",
    backwards_navigation_enabled: true,
    title: "Your profile",
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "choose_treatments",
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "Have you tried treating your Phobia?",
      description: "Choose all that apply",
      image: null,
      custom_back: null,
      default_progression: "age_select_page",
      options: [
        {
          id: `option-item-0-${generate()}`,
          label: "I've not tried anything",
          value: "not_tried_anything",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "I've tried therapy",
          value: "tried_therapy",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "I'm currrently seeing a therapist",
          value: "seeing_therapist",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-3-${generate()}`,
          label: "I Google for information",
          to: "gender_select_page",
          value: "googled_information",
          target_field: "choose_treatments",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-4-${generate()}`,
          label: "I've used another app",
          value: "used_another_app",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-5-${generate()}`,
          label: "I've used anti-anxiety medication",
          value: "used_anti_anxiety_medication",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-6-${generate()}`,
          label: "Something else",
          value: "something_else",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  age_select_page_vaping: {
    id: `age_select_page_vaping-${generate()}`,
    type: "single_select_type",
    backwards_navigation_enabled: true,
    title: "Your profile",
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "age_select",
    target_pages: [],
    component_type: "centered",
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "How old are you?",
      description: "We’ll tailor your program to your age group",
      image: null,
      default_progression: "gender_select_page_vaping",
      custom_back: null,
      options: [
        {
          id: `option-item-0-${generate()}`,
          label: "Under 12",
          to: "gender_select_page_vaping",
          value: "under_12",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "13 - 14",
          to: "gender_select_page_vaping",
          value: "13-14",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "15 - 16",
          to: "gender_select_page_vaping",
          value: "15-16",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-3-${generate()}`,
          label: "17 - 18",
          to: "gender_select_page_vaping",
          value: "17-18",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-4-${generate()}`,
          label: "19+",
          value: "19+",
          to: "gender_select_page_vaping",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  gender_select_page_vaping: {
    id: `gender_select_page-${generate()}`,
    type: "single_select_type",
    backwards_navigation_enabled: true,
    title: "Your profile",
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "choose_gender",
    target_pages: [],
    component_type: "centered",
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What's your gender?",
      description:
        "This helps us personalize your plan. Gender affects anxiety. We also experience anxiety differently across genders.",
      image: null,
      custom_back: null,
      default_progression: null,
      options: [
        {
          id: `option-item-0-${generate()}`,
          label: "Male",
          to: "why_im_doing_this_program_vaping",
          value: "male",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "Female",
          to: "why_im_doing_this_program_vaping",
          value: "female",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "Non-binary",
          to: "why_im_doing_this_program_vaping",
          value: "non-binary",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-3-${generate()}`,
          label: "Prefer not to say",
          to: "why_im_doing_this_program_vaping",
          value: "prefer_not_to_say",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  ethnicity_page: {
    id: `ethnicity_page-${generate()}`,
    type: "ethnicity_type",
    custom_back: null,
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "choose_ethnicity",
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What's your ethnicity?",
      description: "Choose all that apply",
      image: null,
      custom_back: null,
      default_progression: "why_im_doing_this_program_vaping",
      options: [
        {
          id: `option-item-0-${generate()}`,
          label: "NZ European",
          value: "nz_european",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "Māori",
          value: "maori",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "Pasifika",
          value: "pasifika",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "Asian",
          value: "asian",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  why_im_doing_this_program_vaping: {
    id: `why_im_doing_this_program_vaping-${generate()}`,
    type: "single_select_type",
    backwards_navigation_enabled: true,
    title: "Your profile",
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "reason_select",
    target_pages: [],
    component_type: "centered",
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "I'm doing this vaping program because:",
      description: "Choose one answer that means the most to you.",
      image: null,
      default_progression: "web_payment_setup_account_page",
      custom_back: null,
      options: [
        {
          id: `option-item-0-${generate()}`,
          label: "I want to get better at sports",
          to: "web_payment_setup_account_page",
          value: "get_better_at_sports",
          target_field: "reason_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "I want to be healthier",
          to: "web_payment_setup_account_page",
          value: "be_healthier",
          target_field: "reason_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "I know it’s a bad habit and want to stop",
          to: "web_payment_setup_account_page",
          value: "bad_habit",
          target_field: "reason_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-3-${generate()}`,
          label: "I want to keep family happy",
          to: "web_payment_setup_account_page",
          value: "keep_family_happy",
          target_field: "reason_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-4-${generate()}`,
          label: "I want to get teachers off my back",
          value: "get_teachers_off_back",
          to: "web_payment_setup_account_page",
          target_field: "reason_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-5-${generate()}`,
          label: "I feel like I’m being played by tobacco companies",
          value: "played_by_tobacco_companies",
          to: "web_payment_setup_account_page",
          target_field: "reason_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-6-${generate()}`,
          label: "I want to save money",
          value: "save_money",
          to: "web_payment_setup_account_page",
          target_field: "reason_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-7-${generate()}`,
          label: "Something else",
          value: "something_else",
          to: "web_payment_setup_account_page",
          target_field: "reason_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
};
